import 'reflect-metadata'
import {injectable} from 'inversify'
import {runInAction, makeAutoObservable} from 'mobx'
import {message} from 'antd'
import {createSession, getSession} from './services'
import {IDigitalReceiptsButtonsStore} from '~/code/pages/DigitalReceipts/components/DigitalReceiptsButtons/IDigitalReceiptsButtonsStore'
import {DIGITAL_RECEIPTS_SESSION_ID_KEY} from '@/constants/auth-constants'

@injectable()
export class DigitalReceiptsButtonsStore implements IDigitalReceiptsButtonsStore {
    isStartTrialModalOpen: boolean = false
    isStartTrialSuccessModalOpen: boolean = false
    isGoToModalOpen: boolean = false

    isStartTrialLoading: boolean = false
    isGoToLoading: boolean = false

    constructor() {
        makeAutoObservable(this)
    }

    openStartTrialModal = () => {
        this.isStartTrialModalOpen = true
    }

    closeStartTrialModal = () => {
        this.isStartTrialModalOpen = false
    }

    openStartTrialSuccessModal = () => {
        this.isStartTrialSuccessModalOpen = true
    }

    closeStartTrialSuccessModal = () => {
        this.isStartTrialSuccessModalOpen = false
    }

    openGoToModal = () => {
        this.isGoToModalOpen = true
    }

    closeGoToModal = () => {
        this.isGoToModalOpen = false
    }

    startFreeTrial = async () => {
        try {
            this.isStartTrialLoading = true

            const result = await createSession()

            if (result) {
                runInAction(() => {
                    this.closeStartTrialModal()
                    this.openStartTrialSuccessModal()
                })
            }
        } catch (error) {
            message.error(error?.message)
        } finally {
            runInAction(() => {
                this.isStartTrialLoading = false
            })
        }
    }

    getDigitalReceiptsRedirectUrl = async (): Promise<string | null> => {
        const baseUrl = _IS_PROD_
            ? _DIGITAL_RECEIPTS_REDIRECT_PROD_URL_
            : _DIGITAL_RECEIPTS_REDIRECT_TEST_URL_

        try {
            this.isGoToLoading = true

            const {result} = await getSession()

            if (!result?.sessionId) {
                return null
            }

            return `${baseUrl}?${DIGITAL_RECEIPTS_SESSION_ID_KEY}=${encodeURIComponent(result.sessionId)}`
        } catch (error) {
            message.error(error?.message)
            return null
        } finally {
            runInAction(() => {
                this.isGoToLoading = false
            })
        }
    }
}
